// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bQMxD","name":"styles_name__sKs2m","phone":"styles_phone__1BHs9"};